export default __webpack_public_path__ + "static/media/evo-icon-active.a4213d1d.svg";